import React from 'react'
import Resume from '../../assets/JP-SALAZAR-CV.pdf'

const CV = () => {
    return (
        <div className='cta'>
            <a href={Resume} target='_blank' className='btn'>My Resume</a>
            <a href='#contact' className='btn btn-primary'>Let's Talk</a>

        </div>
    )
}

export default CV